import fetcher from '../fetcher'

import config from '../../config'
import { UserAccess } from './types'
import { User } from '../users/types'

/**
 * Get available access for email
 * @returns UserAccess | null
 */
export const getAvailableAccess = async (email: string): Promise<UserAccess | null> => {
  const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/auth/access-available?email=${encodeURIComponent(email)}`, {
    method: 'GET'
  })
  return res.data
}

/**
 * This is call only once after login to sync if needed Cognito with our database.
 * This requirements comes because we replace our staging db with our production db.
 * Doing that might change the id/tenantId of the user.
 * This call will sync Cognito with the records in our database.
 * @returns
 */
export const syncUser = async (): Promise<boolean> => {
  const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/auth/sync-user`, {
    method: 'GET'
  })
  return res.data
}

export const saveLinkedinUserProfile = async (_: string, { arg }: { arg: string }): Promise<{ sub: string, name: string, lastName: string }> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/auth/linkedin-verification`, {
      method: 'POST',
      body: JSON.stringify({ code: arg })
    })
    // save in local storage
    sessionStorage.setItem('linkedinUser', JSON.stringify(res.data))
    return res.data
  } catch (error: unknown) {
    sessionStorage.removeItem('linkedinUser')
    throw error
  }
}

export const loginSuccess = async (): Promise<User> => {
  const rest = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/auth/login/success`, {
    method: 'POST',
  })
  return rest.data
}
